import { Link } from "react-router-dom";
import { useBrandAnswer } from "@fox1ck-org/auth/saas/react";
import { Button, ErrorPage } from "@fox1ck-org/ui";

import { useT } from "@/lib/i18n";

/**
 * An address the tracker has no screen for (board TEdges «404 и ошибка»): the
 * kit's ErrorPage on the brand's ground — its motif and the product's mark,
 * what happened and one way out (to the campaigns) — instead of silently
 * landing on the dashboard.
 */
export default function NotFoundPage() {
  const t = useT();
  const { mark, motif } = useBrandAnswer();
  return (
    <div className="flex min-h-0 flex-1 flex-col" data-testid="not-found">
      <ErrorPage
        kind="not-found"
        locale="ru"
        mark={mark}
        motif={motif}
        title={t("notFound.title")}
        description={t("notFound.body")}
        action={
          <Button asChild>
            <Link to="/campaigns">{t("notFound.cta")}</Link>
          </Button>
        }
      />
    </div>
  );
}
